import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { APIService } from '@fourcomply-admin/shared';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "i18n/", ".json?v=2.5.0");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom([
      FormlyModule.forRoot({
        validationMessages: [{ name: "required", message: "Required" }],
        types: [
          {
            name: 'hidden',
            defaultOptions: {
              templateOptions: {
                type: 'hidden',
              },
            },
          },
        ],
      }),
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          deps: [HttpClient],
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory
        }
      })
    ]),
    provideHttpClient(),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'MM/dd/yyyy hh:mm zzz' }
    },
    APIService
  ]
};
